import { useQuery } from '@tanstack/react-query';
import { fetchLocations } from '../api/locations';
import { Location } from '../types/locations';

export function useLocations() {
  return useQuery<Location[]>({
    queryKey: ['locations'],
    queryFn: async () => {
      const response = await fetchLocations();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}





